export const userStatus = {
  methods: {
    async checkUserStatus() {
      await this.$store.dispatch('user/status')
      var status
      if (!this.$store.state.user.status.name) {
        status = 'name'
      } else if (!this.$store.state.user.status.profile) {
        status = 'profile'
      } else if (!this.$store.state.user.status.genres) {
        status = 'genres'
      } else if (!this.$store.state.user.status.artists) {
        status = 'artists'
      } else {
        status = 'home'
      }
      return status
    }
  }
}
